import * as ReactDOMClient from 'react-dom/client'
import ReactGA from 'react-ga4'
import { Provider } from 'react-redux'

import './libs/vh'
import './babu.css'

import AppPage from './components/app/AppPage'
import LoadingOverlayPage from './components/app/LoadingOverlayPage'
import SnackbarsPage from './components/snackbars/SnackbarsPage'
import { GA4MeasurementID } from './libs/constants'
import * as serviceWorker from './serviceWorker'
import store from './store'

ReactGA.initialize(GA4MeasurementID)

const rootContainer = document.getElementById('root')
if (!rootContainer) {
  throw new Error('root not found')
}
const root = ReactDOMClient.createRoot(rootContainer)

root.render(
  // TODO
  // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment
  <Provider store={store}>
    <AppPage />
    <LoadingOverlayPage />
    <SnackbarsPage />
  </Provider>,
)

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister()
